/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiQueryTemplate } from './ApiQueryTemplate';
import {
    ApiQueryTemplateFromJSON,
    ApiQueryTemplateFromJSONTyped,
    ApiQueryTemplateToJSON,
    ApiQueryTemplateToJSONTyped,
} from './ApiQueryTemplate';

/**
 * 
 * @export
 * @interface ApiQueryTemplateUpdate
 */
export interface ApiQueryTemplateUpdate {
    /**
     * 
     * @type {ApiQueryTemplate}
     * @memberof ApiQueryTemplateUpdate
     */
    oldVersion?: ApiQueryTemplate;
    /**
     * 
     * @type {ApiQueryTemplate}
     * @memberof ApiQueryTemplateUpdate
     */
    newVersion?: ApiQueryTemplate;
}

/**
 * Check if a given object implements the ApiQueryTemplateUpdate interface.
 */
export function instanceOfApiQueryTemplateUpdate(value: object): value is ApiQueryTemplateUpdate {
    return true;
}

export function ApiQueryTemplateUpdateFromJSON(json: any): ApiQueryTemplateUpdate {
    return ApiQueryTemplateUpdateFromJSONTyped(json, false);
}

export function ApiQueryTemplateUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiQueryTemplateUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'oldVersion': json['oldVersion'] == null ? undefined : ApiQueryTemplateFromJSON(json['oldVersion']),
        'newVersion': json['newVersion'] == null ? undefined : ApiQueryTemplateFromJSON(json['newVersion']),
    };
}

export function ApiQueryTemplateUpdateToJSON(json: any): ApiQueryTemplateUpdate {
    return ApiQueryTemplateUpdateToJSONTyped(json, false);
}

export function ApiQueryTemplateUpdateToJSONTyped(value?: ApiQueryTemplateUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oldVersion': ApiQueryTemplateToJSON(value['oldVersion']),
        'newVersion': ApiQueryTemplateToJSON(value['newVersion']),
    };
}

